import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Format a backend error (including FastAPI 422 validation arrays) into
// a readable French string.
export function formatApiError(err) {
    if (!err) return "Une erreur est survenue.";
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((d) => {
                const field = Array.isArray(d?.loc) ? d.loc.slice(1).join(".") : "";
                const msg = d?.msg || "";
                return field ? `${field} : ${msg}` : msg;
            })
            .join(" · ");
    }
    if (detail && typeof detail === "object") {
        return detail.msg || JSON.stringify(detail);
    }
    return err.message || "Erreur inconnue.";
}

// Attach admin JWT if present
api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("ana_admin_token");
    if (token && cfg.url && cfg.url.startsWith("/admin")) {
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

// Public endpoints
export const listBlogPosts = () => api.get("/blog/posts").then((r) => r.data);
export const getBlogPost = (slug) =>
    api.get(`/blog/posts/${slug}`).then((r) => r.data);
export const createAppointment = (payload) =>
    api.post("/appointments", payload).then((r) => r.data);
export const createContact = (payload) =>
    api.post("/contact", payload).then((r) => r.data);
export const createReferrer = (payload) =>
    api.post("/referrers", payload).then((r) => r.data);
export const getSiteSettings = () =>
    api.get("/settings").then((r) => r.data);

// Admin
const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("ana_admin_token")}`,
});
export const adminLogin = (email, password) =>
    api.post("/admin/login", { email, password }).then((r) => r.data);
export const listAppointmentsAdmin = () =>
    api.get("/appointments", { headers: authHeaders() }).then((r) => r.data);
export const updateAppointmentStatus = (id, status) =>
    api.patch(`/appointments/${id}`, { status }, { headers: authHeaders() }).then((r) => r.data);
export const listContactsAdmin = () =>
    api.get("/contact", { headers: authHeaders() }).then((r) => r.data);
export const adminDeleteContact = (id) =>
    api.delete(`/contact/${id}`, { headers: authHeaders() }).then((r) => r.data);
export const listReferrersAdmin = () =>
    api.get("/referrers", { headers: authHeaders() }).then((r) => r.data);
export const adminCreateBlogPost = (payload) =>
    api.post("/admin/blog/posts", payload, { headers: authHeaders() }).then((r) => r.data);
export const adminUpdateBlogPost = (slug, payload) =>
    api.patch(`/admin/blog/posts/${slug}`, payload, { headers: authHeaders() }).then((r) => r.data);
export const adminDeleteBlogPost = (slug) =>
    api.delete(`/admin/blog/posts/${slug}`, { headers: authHeaders() }).then((r) => r.data);

// Referrer portal (magic link)
const referrerAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("ana_referrer_token")}`,
});
export const referrerRequestAccess = (email) =>
    api.post("/referrer/request-access", { email }).then((r) => r.data);
export const referrerMe = () =>
    api.get("/referrer/me", { headers: referrerAuthHeaders() }).then((r) => r.data);
export const referrerPatients = () =>
    api.get("/referrer/patients", { headers: referrerAuthHeaders() }).then((r) => r.data);

// Site settings — admin
export const adminUpdateSiteSettings = (payload) =>
    api.patch("/admin/settings", payload, { headers: authHeaders() }).then((r) => r.data);

// Admin — change email + password
export const adminChangeCredentials = (payload) =>
    api.post("/admin/change-credentials", payload, { headers: authHeaders() }).then((r) => r.data);
